import { getTencentImAccountSign, getImGroupId } from '@/api/live'
import route from '@/router'

export const tencentIm = () => {
  let params = {}
  if (route.app._route.query.platformUserType === 'assistant') {
    params = {
      type: `1${route.app._route.query.tencentIdType}`
    }
  }
  return getTencentImAccountSign(params).then(res => {
    // sdkAppId 聊天室应用ID
    // sign用户签名
    // status 状态 1 正常 0 禁言
    // userId 用户ID
    return res
  }).catch((e) => {
    console.log(e)
  })
}
// 获取群ID
export const getTencentImGroupId = (roomId) => {
  // 获取群id
  return getImGroupId({
    roomId: roomId
  }).then(res => {
    // window.access_token = res.access_token
    return res
  }).catch((e) => {
    console.log(e)
  })
}

export const isWeChat = () => {
  var ua = window.navigator.userAgent.toLowerCase()
  // eslint-disable-next-line eqeqeq
  return ua.match(/MicroMessenger/i) == 'micromessenger'
}
// 微信环境判断
export const getIsWxClient = () => {
  var ua = navigator.userAgent.toLowerCase()
  // eslint-disable-next-line eqeqeq
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    return true
  }
  return false
}
export const getParam = () => {
  // 将url后面的参数 ?name=msea&sex=1  >{name:"msea",sex:1}
  var search = {}
  if (location.search === '') return {}
  try {
    location.search
      .substr(1)
      .split('&')
      .forEach(function(item) {
        var s = item.split('=')
        search[s[0]] = s[1]
      })
  } catch (e) {
    // 抛出异常
    throw new Error(JSON.stringify(search))
  }
  return search
}
export const getUserAgent = () => {
  const u = navigator.userAgent
  const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 // 判断是否是 android终端
  const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // 判断是否是 iOS终端
  if (isAndroid) {
    return 'Android'
  } else if (isIOS) {
    return 'IOS'
  } else {
    return 'PC'
  }
}

// 上报点击埋点
import { reportClickData } from '@/api/live'

export const postClickTrack = (clickParamsData) => {
  if (route.app._route.query.platformUserType === 'assistant') {
    return false
  }
  // console.log('上报埋点事件')
  // console.log(clickParamsData)
  reportClickData(clickParamsData).then(res => {
  }).catch((e) => {
    console.log(e)
  })
}

export const second2HMS = (d, str) => {
  d = parseInt(d, 10)
  var h = Math.floor(d / 3600)
  var m = Math.floor(d % 3600 / 60)
  var s = Math.floor(d % 3600 % 60)
  var times = ''
  function format(num) {
    var val = 0
    if (num > 0) {
      if (num >= 10) {
        val = num
      } else {
        val = '0' + num
      }
    } else {
      val = '00'
    }
    return val
  }
  var hr = format(h)
  var min = format(m)
  var sec = format(s)

  if (str) {
    if (str === 'total') {
      if (hr > 0) {
        times = hr + ':' + min + ':' + sec
      } else {
        times = min + ':' + sec
      }
    } else if (str === 'cur') {
      if (hr > 0) {
        times = hr + ':' + min + ':' + sec
      } else {
        times = '00:' + min + ':' + sec
      }
    }
  }
  return times
}
// 判断项目类型
export const getProjectType = (projectId) => {
  if (process.env.VUE_APP_MODE === 'production') {
    if ([1, 2, 3, 4].includes(projectId)) {
      return {
        type: 2
      }
    } else if ([].includes(projectId)) {
      return {
        type: 1
      }
    }
  } else {
    if ([7, 9, 10].includes(projectId)) {
      // 营养项目
      return {
        type: 1
      }
    } else if ([1, 2, 3, 4, 8, 11, 12].includes(projectId)) {
      // 养生
      return {
        type: 2
      }
    }
  }
}

export const extractParamLegacy = (url, paramName) => {
  // 步骤1：去除 URL 中的哈希部分（# 及后面内容）
  const urlWithoutHash = url.split('#')[0]
  // 步骤2：提取查询参数部分（? 后面的内容）
  const queryIndex = urlWithoutHash.indexOf('?')
  if (queryIndex === -1) return null // 无查询参数，返回 null
  const queryString = urlWithoutHash.slice(queryIndex + 1)
  // 步骤3：分割所有参数，遍历查找
  const params = queryString.split('&')
  for (const param of params) {
    const [key, value] = param.split('=')
    if (key === paramName && value) {
      return value
    }
  }
  return null // 未找到参数
}

export const downloadApp = (url) => {
  if (!url) return
  window.open(url, '_blank')
}

export function isWeChatEnv() {
  const userAgent = navigator.userAgent.toLowerCase()
  return /micromessenger/.test(userAgent)
}

export function judgeBrand(sUserAgent) {
  var isIphone = sUserAgent.match(/iphone/i) === 'iphone'
  var isHuawei = sUserAgent.match(/huawei/i) === 'huawei'
  var isHonor = sUserAgent.match(/honor/i) === 'honor'
  var isOppo = sUserAgent.match(/oppo/i) === 'oppo'
  var isOppoR15 = sUserAgent.match(/pacm00/i) === 'pacm00'
  var isVivo = sUserAgent.match(/vivo/i) === 'vivo'
  var isXiaomi = sUserAgent.match(/mi\s/i) === 'mi '
  var isXiaomi2s = sUserAgent.match(/mix\s/i) === 'mix '
  var isRedmi = sUserAgent.match(/redmi/i) === 'redmi'
  var isSamsung = sUserAgent.match(/sm-/i) === 'sm-'
  var isLG = sUserAgent.match(/lg/i) === 'lg'
  if (isIphone) {
    return 'iphone'
  } else if (isHuawei || isHonor) {
    return 'huawei'
  } else if (isOppo || isOppoR15) {
    return 'oppo'
  } else if (isVivo) {
    return 'vivo'
  } else if (isXiaomi || isRedmi || isXiaomi2s) {
    return 'xiaomi'
  } else if (isSamsung) {
    return 'samsung'
  } else if (isLG) {
    return 'lg'
  } else {
    return 'other'
  }
}

